(function () {
  'use strict';

  class AjaxAddToCart {
    constructor() {
      this.init();
    }

    init() {
      document.addEventListener('DOMContentLoaded', () => {
        this.bindEvents();
      });
    }

    bindEvents() {
      const addToCartForms = document.querySelectorAll('[data-type="add-to-cart-form"]');

      addToCartForms.forEach(form => {
        form.addEventListener('submit', this.handleFormSubmit.bind(this));
      });

      document.addEventListener('click', (event) => {
        const button = event.target.closest('.t4s-sticky-atc__atc');
        if (button && button.hasAttribute('data-action-atc')) {
          event.preventDefault();
          event.stopPropagation();
          this.handleStickyAddToCart(event);
        }
      });

      document.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-cart-remove]');
        if (removeButton) {
          event.preventDefault();
          event.stopPropagation();
          this.handleRemoveItem(event, removeButton);
        }
      });
    }

    async handleFormSubmit(event) {
      event.preventDefault();

      const form = event.target;
      const submitButton = form.querySelector('[data-atc-form]');

      if (!submitButton || submitButton.disabled) {
        return;
      }

      const originalButtonText = submitButton.innerHTML;

      try {
        submitButton.disabled = true;
        submitButton.innerHTML = '<span>Adding...</span>';

        const formData = new FormData(form);
        const data = {
          id: formData.get('id'),
          quantity: formData.get('quantity') || 1
        };

        const properties = {};
        formData.forEach((value, key) => {
          if (key.startsWith('properties[')) {
            const propertyName = key.match(/properties\[(.+)\]/)[1];
            properties[propertyName] = value;
          }
        });

        if (Object.keys(properties).length > 0) {
          data.properties = properties;
        }

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          throw new Error('Failed to add item to cart');
        }

        const addedItem = await response.json();

        await this.updateCartCount();

        this.openCartDrawer();

        submitButton.innerHTML = '<span>Added!</span>';

        setTimeout(() => {
          submitButton.innerHTML = originalButtonText;
          submitButton.disabled = false;
        }, 2000);

      } catch (error) {
        console.error('Error adding to cart:', error);
        submitButton.innerHTML = '<span>Error</span>';

        setTimeout(() => {
          submitButton.innerHTML = originalButtonText;
          submitButton.disabled = false;
        }, 2000);
      }
    }

    async handleStickyAddToCart(event) {
      event.preventDefault();

      const button = event.target.closest('.t4s-sticky-atc__atc');

      if (!button || button.disabled || button.hasAttribute('aria-disabled')) {
        return;
      }

      const variantId = button.getAttribute('data-variant-id');
      const buttonTextElement = button.querySelector('.t4s-btn-atc_text');

      if (!buttonTextElement) {
        return;
      }

      const originalButtonText = buttonTextElement.innerHTML;

      try {
        button.disabled = true;
        buttonTextElement.innerHTML = 'Adding...';

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (!response.ok) {
          throw new Error('Failed to add item to cart');
        }

        await response.json();
        await this.updateCartCount();
        this.openCartDrawer();

        buttonTextElement.innerHTML = 'Added!';

        setTimeout(() => {
          buttonTextElement.innerHTML = originalButtonText;
          button.disabled = false;
        }, 2000);

      } catch (error) {
        console.error('Error adding to cart:', error);
        buttonTextElement.innerHTML = 'Error';

        setTimeout(() => {
          buttonTextElement.innerHTML = originalButtonText;
          button.disabled = false;
        }, 2000);
      }
    }

    async handleRemoveItem(event, button) {
      const itemKey = button.getAttribute('data-id');
      if (!itemKey) {
        return;
      }

      const cartItem = button.closest('[data-cart-item]');
      if (cartItem) {
        cartItem.style.opacity = '0.5';
        cartItem.style.pointerEvents = 'none';
      }

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        });

        if (!response.ok) {
          throw new Error('Failed to remove item from cart');
        }

        await this.updateCartCount();

      } catch (error) {
        console.error('Error removing item from cart:', error);
        if (cartItem) {
          cartItem.style.opacity = '1';
          cartItem.style.pointerEvents = 'auto';
        }
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
          if (cart.item_count > 0) {
            element.classList.remove('t4s-op-0');
          } else {
            element.classList.add('t4s-op-0');
          }
        });

        const cartWrapper = document.querySelector('[data-cart-wrapper]');
        if (cartWrapper) {
          cartWrapper.setAttribute('data-ccount', cart.item_count);
        }

        this.updateCartContent();

      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }

    async updateCartContent() {
      try {
        const response = await fetch('/?section_id=mini_cart');
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const cartItems = doc.querySelector('[data-cart-items]');
        const currentCartItems = document.querySelector('[data-cart-items]');

        if (cartItems && currentCartItems) {
          currentCartItems.innerHTML = cartItems.innerHTML;
        }

        const cartPrices = doc.querySelector('[data-cart-prices]');
        const currentCartPrices = document.querySelector('[data-cart-prices]');

        if (cartPrices && currentCartPrices) {
          currentCartPrices.innerHTML = cartPrices.innerHTML;
        }

        const cartTotalPrice = doc.querySelector('[data-er-cart-total-price]');
        const currentCartTotalPrice = document.querySelector('[data-er-cart-total-price]');

        if (cartTotalPrice && currentCartTotalPrice) {
          currentCartTotalPrice.innerHTML = cartTotalPrice.innerHTML;
        }

      } catch (error) {
        console.error('Error updating cart content:', error);
      }
    }

    openCartDrawer() {
      const miniCart = document.getElementById('t4s-mini_cart');
      if (!miniCart) {
        console.error('Mini cart drawer not found');
        return;
      }

      const overlay = document.querySelector('.t4s-close-overlay');

      if (overlay) {
        overlay.classList.add('is--visible');
      }

      miniCart.classList.add('is--visible');
      miniCart.setAttribute('aria-hidden', 'false');
      document.body.classList.add('t4s-drawer-open');

      const closeButtons = miniCart.querySelectorAll('[data-drawer-close]');
      closeButtons.forEach(button => {
        button.addEventListener('click', () => {
          this.closeCartDrawer();
        });
      });

      if (overlay) {
        overlay.addEventListener('click', () => {
          this.closeCartDrawer();
        });
      }
    }

    closeCartDrawer() {
      const miniCart = document.getElementById('t4s-mini_cart');
      const overlay = document.querySelector('.t4s-close-overlay');

      if (miniCart) {
        miniCart.classList.remove('is--visible');
        miniCart.setAttribute('aria-hidden', 'true');
      }

      if (overlay) {
        overlay.classList.remove('is--visible');
      }

      document.body.classList.remove('t4s-drawer-open');
    }
  }

  new AjaxAddToCart();
})();
